import { render, staticRenderFns } from "./UserReturnInfo.vue?vue&type=template&id=5656f8c6"
import script from "./UserReturnInfo.vue?vue&type=script&lang=js"
export * from "./UserReturnInfo.vue?vue&type=script&lang=js"
import style0 from "./UserReturnInfo.vue?vue&type=style&index=0&id=5656f8c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports